export default "__VITE_ASSET__vhYdusAU__"